import { PageMeta } from "@/components/common/Seo/PageMeta"
import ResearchPage from "@/components/products/research/ResearchPage"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "Crypto research service",
        description:
          "A dedicated research service with decision-ready onchain insights, powered by Token Terminal's full data warehouse. Contact us to discuss your research needs.",
      }}
    />
    <ResearchPage />
  </>
)

export default index
